import { site } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';

const {
  track,
  constants: { events, triggerIds },
} = segment;

const trackBusinessCategoryInputFocused = ({ category }) => {
  const siteId = site.accessors.getSiteId();

  track(events.BUSINESS_CATEGORY_INPUT_FOCUSED, {
    siteId,
    stepId: null,
    source: triggerIds.WEBSITE_SETTINGS,
    businessCategory: category,
  });
};

export default trackBusinessCategoryInputFocused;
